import { Box, Image, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { CustomPrimaryButton } from 'components/Buttons';
import Modal from 'components/Modal/Modal';

import model from './img/model.webp';
import { GoalModalPropsType } from './types';

import * as S from './styled';

const GoalModal = ({ onClick }: GoalModalPropsType) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen onClose={onClick} paddingX={0} paddingY={0}>
            <Box $paddingTop={16} $paddingX={16} $paddingBottom={44} $backgroundColor="surface-default">
                <div data-locator="goalTodayWindow" data-testid="goalTodayWindow">
                    <Image maxWidth={390} mb={10} alt="model image" src={model} />
                    <Text type="h5" mb={4}>
                        {t('personalPlan.planPreview.goalTitle.available')}
                    </Text>
                    <Text>{t('personalPlan.planPreview.goalModal.description')}</Text>
                    <S.ButtonWrapper>
                        <CustomPrimaryButton
                            dataLocator="closeGoalTodayBtn"
                            dataTestId="closeGoalTodayBtn"
                            onClick={onClick}
                        >
                            {t('basics.gotIt')}
                        </CustomPrimaryButton>
                    </S.ButtonWrapper>
                </div>
            </Box>
        </Modal>
    );
};

export default GoalModal;
